const debounce = (fn, wait) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};

class ContentGridSection extends HTMLElement {
  constructor() {
    super();
    this.summary = this.querySelector("[data-summary]");
    this.content = this.querySelector("[data-content]");
    this.toggle = this.querySelector("[data-toggle]");

    this.summary.addEventListener("click", (e) => {
      if (this._allowToggle) {
        this.isOpen ? this.close() : this.open();
      }
    });

    this.toggle.addEventListener("click", () => {
      if (!this._allowToggle) return;

      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    });

    this.lastAllowToggle = null;

    const toggleOpen = () => {
      if (!this._allowToggle) {
        this._forceOpen();
      } else if (this.lastAllowToggle === false && this._allowToggle) {
        this._forceClosed();
      }

      this.lastAllowToggle = this._allowToggle;
    };

    toggleOpen();

    this.onResize = debounce(toggleOpen, 200);

    window.addEventListener("resize", this.onResize);
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.onResize);
  }

  _forceOpen() {
    this.removeEventListener("transitionend", this.handleTransitionEnd);
    this.setAttribute("open", "");
    this.content.style.height = null;
    this.content.style.opacity = null;
  }

  _forceClosed() {
    this.removeEventListener("transitionend", this.handleTransitionEnd);
    this.removeAttribute("open");
    this.content.style.height = null;
    this.content.style.opacity = null;
  }

  get isOpen() {
    return this.hasAttribute("open");
  }

  open() {
    if (this.isOpen) return;
    this.removeEventListener("transitionend", this.handleTransitionEnd);
    this.setAttribute("open", "");
    if (this.content) {
      this.content.style.height = 0;
      this.content.style.opacity = 0;

      // setTimeout(() => {
      //   this.content.style.height = `${this.content.scrollHeight}px`;
      //   this.content.style.opacity = 1;
      // }, 500);

      window.requestAnimationFrame(() => {
        this.content.style.height = `${this.content.scrollHeight}px`;
        this.content.style.opacity = 1;
      });
    }
  }

  close() {
    if (!this.isOpen) return;
    if (this.content) {
      this.removeEventListener("transitionend", this.handleTransitionEnd);

      this.handleTransitionEnd = () => {
        this.removeEventListener("transitionend", this.handleTransitionEnd);
        this.removeAttribute("open");
      };

      this.addEventListener("transitionend", this.handleTransitionEnd);

      this.content.style.height = 0;
      this.content.style.opacity = 0;
    } else {
      this.removeAttribute("open");
    }
  }

  get _allowToggle() {
    return window.matchMedia(this._mediaQuery).matches;
  }

  get _mediaQuery() {
    return this.getAttribute("allow-toggle-when") || "all";
  }
}

if (!customElements.get("content-grid-section")) {
  customElements.define("content-grid-section", ContentGridSection);
}
